<template>
  <div class="p-information">
    <CardTitle>信息化建设覆盖</CardTitle>
    <ul>
      <li class="card">
        <div class="card-content">
          <p class="card-content__title">学校</p>
          <p class="card-content__count">52</p>
        </div>
      </li>
      <li class="card">
        <div class="card-content">
          <p class="card-content__title">教师</p>
          <p class="card-content__count">1,308</p>
        </div>
      </li>
      <li class="card">
        <div class="card-content">
          <p class="card-content__title">学生</p>
          <p class="card-content__count">85,792</p>
        </div>
      </li>
      <li class="card">
        <div class="card-content">
          <p class="card-content__title">家长</p>
          <p class="card-content__count">30,586</p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import CardTitle from './card-title.vue';

export default {
  name: 'InformationStatistics',
  components: {
    CardTitle,
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.p-information {
  box-sizing: border-box;
  padding: 28px;
  width: 402px;
  height: 290px;
  background: url("~@/views/pt/images/exhibition-message_bg.png") no-repeat;
  background-size: 402px 290px;
  ul {
    display: flex;
    flex-wrap: wrap;
    .card {
      margin-top: 20px;
      margin-right: 12px;
      .card-content {
        width: 160px;
        height: 80px;
        background: rgba(131, 92, 255, 0.2);
        border-radius: 4px;
        // opacity: 0.2892;
        text-align: center;
        overflow: hidden;
        &__title {
          margin-top: 16px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #E3E2FF;
          line-height: 21px;
        }
        &__count {
          font-size: 22px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #00DEFF;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
